/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import styles from '../../Maintenance/create/workOrderCreate.module.scss';
import icon from '../../../icons/badging.png';
import DefaultFields from './DefaultFields';
import Panel from '../../../components/panel';
import Button from '../../../components/button/button';
import { initiateApplication, clearApplicationDetails, getApplication, editApplication } from '../redux/actions';
import { getBackendId } from '../../../constants/apiEnv';

class InitiateApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {},
      fieldErrors: {
        phone_number: true,
        email: true,
        company_name: false,
        first_name: true,
        last_name: true
      },
      emsg: false
    };
    this.wrapperRef = React.createRef();
    this.ActionsRef = React.createRef();
    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
  }

  componentDidMount() {
    const { actionDetail,
      match: {
        params: { id }
      }
     } = this.props;
     actionDetail(id);
  }

  componentDidUpdate(prevProps) {
    const {
      history, saveAction, actionClear, errormsg, badgeEdit, editAction,
      match: { params: { id } }
    } = this.props;
    const { isInitialized } = this.state;

      if (id && !isInitialized && badgeEdit && badgeEdit.id && badgeEdit !== prevProps.badgeEdit) {
        this.handleBadgeEdit(badgeEdit);
      }
    if ((saveAction.success === true && prevProps.saveAction.success!==saveAction.success)
          || (editAction && editAction.success === true && prevProps.editAction.success !== editAction.success)) {
      history.push('/badging/List');
      actionClear();
    }
    if (saveAction.message === 'error' && prevProps.saveAction.message !== 'error') {
      this.setState({ emsg: errormsg?.detail });
    }
  }

  static getDerivedStateFromProps(props, state) {
    // grab user from state
    if (props.user && props.user.id && !state.info.reported_by && !props.match.params.id) {
      return {
        ...state,
        info: {
          ...state.info,
          logged_date: moment().format()
        }
      };
    }
    return state;
  }

    handleAnswerChanged = (section, answer, fieldId) => {
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }

    handleFieldErrorChanged = (id, value) => {
      this.setState(prevState => ({
        fieldErrors: {
          ...prevState.fieldErrors,
          [id]: value
        }
      }));
    }

    handleSearchForUser = (value) => {
      const { actionSearchUser } = this.props;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        actionSearchUser(value);
      }, 300);
    }

    handleBadgeEdit = (badgeEdit) => {
    this.setState({
      isInitialized: true,
      info: {
        first_name: badgeEdit.first_name || '',
        last_name: badgeEdit.last_name || '',
        email: badgeEdit.email || '',
        phone_number: badgeEdit.phone_number || ''
      },
      fieldErrors: {
        first_name: !badgeEdit.first_name,
        last_name: !badgeEdit.last_name,
        email: !badgeEdit.email,
        phone_number: !badgeEdit.phone_number
      }
    });
  };

    initialteApplication = async () => {
      const { fieldErrors, info } = this.state;
      const { actionInitiateApplication, user, actionEditApplication, match: { params: { id } } } = this.props;
      const errors = { ...fieldErrors };
      const noErrors = Object.keys(errors)
        .every(k => (errors[k] === false));
      if (noErrors) {
        this.setState({ loading: true });
        const data = { ...info };
        data.phone_number = info.phone_number[0] + info.phone_number.slice(1).replace(/[^\d]/g, '');
        data.created_at = moment().format();
        data.installationId = getBackendId();
        data.company_name = user?.current_tenant?.id;
        data.application_filled_by = 'Applicant';
        if (id) {
        const editData = {
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          phone_number: data.phone_number,
          created_at: moment().format(),
          installationId: data.installationId,
          application_filled_by: data.application_filled_by
        };
        actionEditApplication(id, editData);
      } else {
        data.created_at = moment().format();
        const formData = new FormData();
        Object.keys(data).forEach((k) => {
          formData.append(k, data[k]);
        });
        actionInitiateApplication(formData);
      }
      } else {
        this.setState({ showFormErrors: true });
      }
    }

    cancelBadging = () => {
      this.props.history.push('/badging/List');
    }

    render() {
      const {
        info, showFormErrors, emsg
      } = this.state;
      const { Tenants, user, match: { params: { id } } } = this.props;
      return (
        <>
          <div className={styles.newlog}>
            <SectionHeader
              icon={icon}
              translationID="topbar.badging"
              defaultTitle="Badges"
            />
            <HeaderBack
              translationID="workorder.settings.back"
              translationDefault="Back"
              backRoute={'/badging/select'}
            />
            <div className={`container ${styles.form}`}>
              <Panel
                title="badge.create.Application"
                defaultTitle={id ? 'Edit Badge Application' : 'New Badge Application'}
              >
                <div className={`${styles.content} ${styles.embedded}`}>
                  <DefaultFields
                    info={info}
                    userlist={this.props.users}
                    tenants={Tenants}
                    user={user}
                    handleAnswerChanged={this.handleAnswerChanged}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    showFieldErrors={showFormErrors}
                  />
                </div>
                <h5 className="text-danger text-center">{emsg}</h5>
                <div className={`${styles.footer} ${styles.embedded}`}>
                  <Button onClick={this.cancelBadging} translationID="maintenance.new.cancel"
                    defaultText="Cancel" action="tertiary"
                  />
                  <Button onClick={this.initialteApplication} translationID="wildlife.form.1" className={'float-center mt-2 mb-2 mr-4'}
                    defaultText={id ? 'Update Application' : 'Initiate Application'} action="primary"
                  />
                </div>
              </Panel>
            </div>
          </div>
        </>
      );
    }
}

InitiateApplication.propTypes = {
  match: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  currentModule: state.general.currentModule,
  user: state.auth.profile,
  users: state.inspection.userlist,
  Tenants: state.lease.TenantLookupData,
  saveAction: state.badging.InitiateApplicationAction,
  badgeEdit: state.badging.applicationdata,
  editAction: state.badging.editApplicationAction,
  errormsg: state.badging.errormsg
});

const mapDispatchToProps = dispatch => ({
  actionClear: () => {
    dispatch(clearApplicationDetails());
  },
  actionDetail: (id) => {
    dispatch(getApplication(id));
  },
  actionEditApplication: (id, editData) => {
    dispatch(editApplication(id, editData));
  },
  actionInitiateApplication: (query) => {
    dispatch(initiateApplication(query));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(InitiateApplication));
